import styled from "@emotion/styled";
import {
  DeviceType,
  MediaStyleProperties,
  StyledComponentProps,
} from "../../../system/types/style/StyledComponentProps";
import {
  divideItemBgColorByRoom,
  divideItemBorderColorByRoom,
} from "../../../system/api/util/MeetingRoomUtil";
import { BoldFontWeight } from "../../../styles/font";
import { Box } from "@mui/material";
import {
  Blue100,
  Blue200,
  Blue400,
  Blue500,
  Gray800,
} from "../../../styles/color";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";

export const MeetingRoomListItemStyle = (
  idx: number,
  isSelected: boolean,
  isAvailable: boolean,
  deviceType: DeviceType
) => {
  return {
    width: deviceType === "mobile" ? "100%" : "auto",
    boxSizing: "border-box",
    padding: "2px 4px",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-between",

    background: divideItemBgColorByRoom(isSelected, isAvailable),
    border: `2px solid ${divideItemBorderColorByRoom(isSelected, isAvailable)}`,
    borderRadius: "4px",
    cursor: "pointer",
    boxShadow: `
      0px 2px 1px -1px rgba(0, 0, 0, 0.2), 
      0px 1px 1px 0px rgba(0, 0, 0, 0.14)
    `,
    "&:hover": {
      background: Blue100,
    },
    "&:hover .meeting-room-list-item-reservation-button": {
      background: Blue200,
    },
  };
};

export const MeetingRoomName = styled.p`
  /* font-weight: ${BoldFontWeight}; */
  display: flex;
  justify-content: space-between;
  align-items: "flex-start";
  font-weight: 600;
  font-size: 0.875rem;
`;

export const MeetingRoomStatus = styled(Box)(() => ({
  // height: "20px",
  fontSize: "0.75rem",
  fontWeight: 600,
}));

const MeetingRoomListWrapperWidth: MediaStyleProperties = {
  pc: "220px",
  tablet: "220px",
  mobile: "100%",
};

export const MeetingRoomListWrapper = styled.div<StyledComponentProps>`
  display: flex;
  width: ${({ deviceType }) => MeetingRoomListWrapperWidth[deviceType]};
  flex-direction: column;
  border: 1px solid #dcdfe3;
  border-radius: 4px;
  padding: 8px;
`;

export const MeetingRoomListHeader = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginBottom: "4px",
}));

export const MeetingRoomListItemRow = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
});

export const MeetingRoomReservationButton = styled(Box)({
  fontSize: "0.625rem",
  fontWeight: 600,
  minWidth: "40px",
  textAlign: "center",
  padding: "2px 0",
  borderRadius: "6px",
  background: Blue100,
  color: Blue500,
  "&:hover": {
    backgroundColor: `${Blue400} !important`,
    color: Blue100,
  },
});

export const MeetingRoomListItemRightSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "4px",
});

export const MeetingRoomCapacityWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  fontSize: "0.75rem",
  fontWeight: 500,
  color: Gray800,
});

export const MeetingRoomEmojiPeopleIcon = styled(EmojiPeopleIcon)({
  width: "0.875rem",
  height: "0.875rem",
  // transform: "translateY(1px)",
});

export const MeetingRoomCapacityBox = styled(Box)({
  display: "flex",
  flex: 1,
  minWidth: "16px",
  fontSize: "0.75rem",
  justifyContent: "flex-start",
});
